import { render, staticRenderFns } from "./TariffImport.vue?vue&type=template&id=440e4a25&lang=pug"
import script from "./TariffImport.vue?vue&type=script&lang=js"
export * from "./TariffImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports